import { render, staticRenderFns } from "./VideoContent.vue?vue&type=template&id=434c9491&scoped=true"
import script from "./VideoContent.vue?vue&type=script&lang=js"
export * from "./VideoContent.vue?vue&type=script&lang=js"
import style0 from "./VideoContent.vue?vue&type=style&index=0&id=434c9491&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434c9491",
  null
  
)

export default component.exports